<script>
export default {
  name: 'ContentHeroListBlock',
  props: {
    data: Object
  },
  computed: {
    listStyle() {
      return this.data.style || 'numbered';
    },
    listEl() {
      return this.listStyle === 'numbered' ? 'ol' : 'ul';
    }
  }
};
</script>

<template>
  <div class="hero-list" v-bind:class="`hero-list--${listStyle}`">

    <h2 class="hero-list__title section-title" v-if="data.title">
      {{ data.title }}
    </h2>
    <div class="hero-list__text richtext" v-if="data.text" v-html="data.text"></div>

    <component v-bind:is="listEl" class="hero-list__list">
      <li
        class="hero-list__item"
        v-for="(item, i) in data.list_items"
        v-bind:key="`hero-list-item-${i}`"
      >

        <div class="hero-list__item-icon" v-if="listStyle === 'icon' && item.icon">
          <img
            v-bind:src="item.icon.sizes.large"
            v-bind:alt="item.item_title"
            class="hero-list__item-icon-image"
          />
        </div>

        <div class="hero-list__item-content">
          <h3 class="hero-list__item-title" v-if="item.item_title">
            {{ item.item_title }}
          </h3>
          <div class="hero-list__item-text richtext" v-if="item.item_text" v-html="item.item_text"></div>
          <a
            v-if="item.link"
            v-bind:href="item.link.url"
            class="hero-list__item-link read-more">
            {{ item.link.title }}
          </a>
        </div>

      </li>
    </component>

  </div>
</template>

<style lang="scss">
.hero-list__list {
  list-style: none;
  counter-reset: counter;
  margin: 0;
  padding: 0;
}

.hero-list__item {
  position: relative;
  margin-top: 4rem;
  counter-increment: counter;

  @include breakpoint('xs') {
    padding-top: 5.4rem
  }
}



.hero-list__text,
.hero-list__item-title,
.hero-list__item-text {
  font-size: 1.8rem;
  line-height: 1.3333;
  letter-spacing: 0.033rem;
}

.hero-list__item-title {
  margin-bottom: 0.6rem;
}

.hero-list__text,
.hero-list__item-text {
  margin: 0;
  line-height: 1.6667;
}

.hero-list__item-link {
  margin-top: 3.2rem;
}


// numbered
.hero-list--numbered {
  .hero-list__list {
    margin-top: 5.6rem;
    padding-left: 7.8rem;

    @include breakpoint('xs') {
      padding-left: 0;
    }
  }

  .hero-list__item::before {
    content: counter(counter);
    position: absolute;
    display: block;
    top: -0.2rem;
    left: -7.8rem;
    width: 4.8rem;
    height: 4.8rem;
    color: $color-secondary-alt;
    font-size: 1.8rem;
    border: 1px solid $color-secondary-alt;
    border-radius: 50%;
    text-align: center;
    line-height: 4.8rem;

    @include breakpoint('xs') {
      top: 0;
      left: -0.7rem
    }
  }
}

// icon
.hero-list--icon {
  .hero-list__item {
    display: flex;
    margin-top: 8rem;

    @include breakpoint('xs') {
      flex-direction: column;
      margin-top: 2rem;
    }
  }

  .hero-list__item-icon {
    margin-right: 3.6rem;
    flex: 0 0 9.6rem;

    @include breakpoint('xs') {
      width: 9.6rem;
    }
  }

  .hero-list__item-icon-image {
    width: 100%;
    height: auto;
  }

  .hero-list__item-title {
    margin-top: 0.8rem;
  }

}
</style>
